import axios from './axios';
import store from '@/store';
import useSessionHanlder from '@/lib/useSessionHandler';
import type { AxiosError, AxiosInstance } from 'axios';
import { datadogLogs } from '@datadog/browser-logs';
import { datadogRum } from '@datadog/browser-rum';

/** 요청 inteceptor 처리 */
export const requestInterceptor = (instance: AxiosInstance = axios) => {
  instance.interceptors.request.use(
    function (request) {
      if (request.headers!['X-bypass']) delete request.headers!['X-bypass'];
      else {
        const TOKEN = store.getters['auth/getSessionToken']();
        request.headers!.authorization = TOKEN;
      }
      request.headers!['X-Git-revision'] = __APP_VERSION__;

      datadogLogs.logger.info('API Request Started', {
        method: request.method?.toUpperCase(),
        url: request.url,
        timestamp: new Date().toISOString(),
      });
      return request;
    },

    function (error) {
      const errorContext = {
        'http.status_code': error.response?.status,
        'http.method': error.config?.method?.toUpperCase(),
        'http.url': error.config?.url,
        'error.type': 'api_error',
        'error.message': error.message,
      };
      datadogRum.addError(error, errorContext);

      datadogLogs.logger.error('API Response Error', {
        ...errorContext,
        requestData: error.config?.data,
        responseData: error.response?.data,
        timestamp: new Date().toISOString(),
      });

      return Promise.reject(error);
    }
  );
};

export const responseInterceptor = (instance: AxiosInstance = axios) => {
  instance.interceptors.response.use(
    function (response) {
      // 백엔드 커스텀 에러 표시 부분입니다.
      if (response.data.code === 4000) {
        store.dispatch('alert/updateErrorMsg', response.data.popup);
        store.dispatch('alert/openAlert', true);
      }
      return response;
    },
    function (error: AxiosError) {
      if (error.response) {
        const { failed } = useSessionHanlder();
        const STATUS_CODE = error.response.data.code;
        store.dispatch('alert/openAlert', STATUS_CODE);

        if (STATUS_CODE === 401) failed();
      } else if (error.request) {
        store.dispatch('alert/openAlert', error); // default, 네트워크를 확인해주세요!
      } else {
        store.dispatch('alert/openAlert', error); // default, 네트워크를 확인해주세요!
      }

      return Promise.reject(error);
    }
  );
};

export default function install() {
  requestInterceptor();
  responseInterceptor();
}
